var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.88672 0.125H12.1133C13.0156 0.125 13.4883 1.24219 12.8438 1.88672L7.73047 7C7.30078 7.42969 6.65625 7.42969 6.26953 7L1.15625 1.88672C0.46875 1.24219 0.941406 0.125 1.88672 0.125Z",
    fill: "#4CA6E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow2);
export default __webpack_public_path__ + "static/media/down-arrow2.f5eb706e55887bcac9b5aeddb3110194.svg";
export { ForwardRef as ReactComponent };